import { render, staticRenderFns } from "./nursing_care.vue?vue&type=template&id=57b6cea2&scoped=true&"
import script from "./nursing_care.vue?vue&type=script&lang=js&"
export * from "./nursing_care.vue?vue&type=script&lang=js&"
import style0 from "./nursing_care.vue?vue&type=style&index=0&id=57b6cea2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6cea2",
  null
  
)

export default component.exports